import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  activatePassword,
  activateTotp,
  confirmTotpSetup,
  recoverWithPassword,
  resetUserTwoFactor,
  sendTelegramCode,
  startTelegramLink,
  startTotpSetup,
  verifyStepUp,
} from "@/api/twoFactor";
import { TwoFactorQueryKeys } from "@/tanstackQuery/queries/twoFactor";

export const useStartTotpSetup = () => {
  return useMutation({ mutationFn: startTotpSetup });
};

export const useConfirmTotpSetup = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: confirmTotpSetup,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [TwoFactorQueryKeys.Status] });
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
};

export const useActivateTotp = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: activateTotp,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [TwoFactorQueryKeys.Status] });
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
};

export const useStartTelegramLink = () => {
  return useMutation({ mutationFn: startTelegramLink });
};

// The Telegram link is completed by the bot (/start), not by a request from
// this panel, so there is nothing to mutate here: this owns the cache refresh
// the setup dialog fires once the link lands (socket push or polling).
export const useTelegramLinked = () => {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: [TwoFactorQueryKeys.Status] });
  };
};

export const useSendTelegramCode = () => {
  return useMutation({ mutationFn: sendTelegramCode });
};

export const useVerifyStepUp = () => {
  return useMutation({ mutationFn: verifyStepUp });
};

export const useResetUserTwoFactor = () => {
  return useMutation({ mutationFn: resetUserTwoFactor });
};

export const useActivatePassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: activatePassword,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [TwoFactorQueryKeys.Status] });
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
};

export const useRecoverWithPassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: recoverWithPassword,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [TwoFactorQueryKeys.Status] });
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
};
